import * as yup from "yup";
const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{5,}$/;
// min 5 characters, 1 upper case letter, 1 lower case letter, 1 numeric digit.
export const carSchema = yup.object().shape({
    title: yup.string()
    .max(40, 'مجاز به استفاده بیشتر از 40 کاراکتر نیستید')
    .required('اجباری'),

    pelak1: yup.number().typeError('عددی و 2 رقمی است').positive().integer().required("اجباری")
    .min(10, 'کمتر از 2 رقم مجاز نیست').max(99, 'بیشتر از 2 رقم مجاز نیست'),

    pelak2: yup.string().required('اجباری'),

    pelak3: yup.number().typeError('عددی و 3 رقمی است').positive().integer().required("اجباری")
    .min(100, 'کمتر از 3 رقم مجاز نیست').max(999, 'بیشتر از 3 رقم مجاز نیست'),

    pelak4: yup.number().typeError('عددی و 2 رقمی است').positive().integer().required("اجباری")
    .min(10, 'کمتر از 2 رقم مجاز نیست').max(99, 'بیشتر از 2 رقم مجاز نیست'),

    shasiNo: yup.string().max(30, 'مجاز به استفاده بیشتر از 30 کاراکتر نیستید'),

    // model: yup.number().positive().integer().required("اجباری"),
    productYear: yup.number().typeError('سال ساخت عددی و 4 رقمی است').positive().integer().required("اجباری")
    .min(1000, 'کمتر از 4 رقم مجاز نیست').max(9999, 'بیشتر از 4 رقم مجاز نیست'),

    kilometer: yup.number().typeError('کیلومتر عددی است').positive().min(0,'عددی، مثبت وارد نمایید').integer().required("اجباری"),

    useFuel: yup.number().typeError('مصرف سوخت عددی است').integer().positive().min(0,'عددی، مثبت وارد نمایید'),

    company: yup.string().max(30, 'مجاز به استفاده بیشتر از 30 کاراکتر نیستید'),

    distancePerWeek: yup.number().typeError('متوسط حرکت عددی است').positive().min(1,'عددی، مثبت وارد نمایید').integer().required("اجباری"),


//   lastname: yup.string()
//     .max(20, 'Must be 20 characters or less')
//     .required('Required'),
//   email: yup.string().email("Please enter a valid email").required("Required"),
//   age: yup.number().positive().integer().required("Required"),
//   password: yup
//     .string()
//     .min(5)
//     .matches(passwordRules, { message: "Please create a stronger password" })
//     .required("Required"),
//   confirmPassword: yup
//     .string()
//     .oneOf([yup.ref("password"), null], "Passwords must match")
//     .required("Required"),
});

export const operateSchema = yup.object().shape({
    operKindId: yup.number().positive().integer().required("اجباری"),
    mtbo: yup.number().typeError('دوره تکرار اجباری است').positive().integer().required("اجباری"),
    unit: yup.string().max(10, 'مجاز به استفاده بیشتر از 10 کاراکتر نیستید').required('اجباری'),
    opTitle: yup.string().max(200, 'مجاز به استفاده بیشتر از 200 کاراکتر نیستید').required('اجباری'),
});

export const operateEditSchema = yup.object().shape({
    mtbo: yup.number().typeError('دوره تکرار اجباری است').positive().integer().required("اجباری"),
    lastKm: yup.number().positive().integer().required("اجباری"),
});

export const operdoneSchema = yup.object().shape({
    operKindId: yup.number().positive().integer().required("اجباری"),
    carId: yup.string().required("اجباری"),
    //operDonDate: yup.date.required('اجباری'),
    operDonKM: yup.number().typeError('کیلومتر عددی است').positive().integer().required("اجباری"),
    cost: yup.number().typeError('هزینه عددی است').positive().integer().required("اجباری"),
    description: yup.string().max(450, 'مجاز به استفاده بیشتر از 450 کاراکتر نیستید')
});


export const operdoneEditSchema = yup.object().shape({
    // operDonDate: yup.date.required('اجباری'),
    operDonKM: yup.number().positive().integer().required("اجباری"),
    cost: yup.number().positive().integer().required("اجباری"),
    description: yup.string().max(450, 'مجاز به استفاده بیشتر از 450 کاراکتر نیستید')
});

export const validationRegisterSchema = yup.object().shape({
    name: yup.string()
    .required('نام الزامی است'),
    mobileNumber: yup.string()
    .required('شماره همراه الزامی است')
    .matches(/^09[0-9]{9}$/, 'شماره همراه معتبر نیست (فرمت صحیح: 09123456789)')
    .length(11, 'شماره همراه باید 11 رقم باشد'),
    password: yup.string()
      .required('رمز عبور الزامی است')
      .min(5, 'رمز عبور باید حداقل 5 کاراکتر باشد'),
    //   .matches(/[A-Z]/, 'رمز عبور باید حداقل یک حرف بزرگ داشته باشد')
    //   .matches(/[a-z]/, 'رمز عبور باید حداقل یک حرف کوچک داشته باشد')
    //   .matches(/[0-9]/, 'رمز عبور باید حداقل یک عدد داشته باشد')
    //   .matches(/[!@#$%^&*]/, 'رمز عبور باید حداقل یک کاراکتر خاص داشته باشد'),
    confirmPassword: yup.string()
      .oneOf([yup.ref('password'), null], 'رمز عبور و تکرار آن مطابقت ندارند')
      .required('تکرار رمز عبور الزامی است')
});

export const validationLoginSchema = yup.object().shape({
    phoneNumber: yup.string()
        .required('شماره همراه الزامی است'),
    password: yup.string()
        .required('رمز عبور الزامی است')
});

export const validationChangePassSchema = yup.object().shape({
    password: yup.string()
       .required('رمز عبور الزامی است'),
    newPassword: yup.string()
      .required('رمز عبور الزامی است')
      .min(5, 'رمز عبور باید حداقل 5 کاراکتر باشد'),
    //   .matches(/[A-Z]/, 'رمز عبور باید حداقل یک حرف بزرگ داشته باشد')
    //   .matches(/[a-z]/, 'رمز عبور باید حداقل یک حرف کوچک داشته باشد')
    //   .matches(/[0-9]/, 'رمز عبور باید حداقل یک عدد داشته باشد')
    //   .matches(/[!@#$%^&*]/, 'رمز عبور باید حداقل یک کاراکتر خاص داشته باشد'),
    confirmNewPassword: yup.string()
      .oneOf([yup.ref('password'), null], 'رمز عبور و تکرار آن مطابقت ندارند')
      .required('تکرار رمز عبور الزامی است')
});

export const validationForgotSchema = yup.object().shape({
    phoneNumber: yup.string()
        .required('شماره همراه الزامی است')
        .matches(/^09[0-9]{9}$/, 'شماره همراه معتبر نیست (فرمت صحیح: 09123456789)')
        .length(11, 'شماره همراه باید 11 رقم باشد'),
});

export const validationChangePass2Schema = yup.object().shape({
    newPassword: yup.string()
      .required('رمز عبور الزامی است')
      .min(5, 'رمز عبور باید حداقل 5 کاراکتر باشد'),
    //   .matches(/[A-Z]/, 'رمز عبور باید حداقل یک حرف بزرگ داشته باشد')
    //   .matches(/[a-z]/, 'رمز عبور باید حداقل یک حرف کوچک داشته باشد')
    //   .matches(/[0-9]/, 'رمز عبور باید حداقل یک عدد داشته باشد')
    //   .matches(/[!@#$%^&*]/, 'رمز عبور باید حداقل یک کاراکتر خاص داشته باشد'),
    confirmPassword: yup.string()
      .oneOf([yup.ref('newPassword'), null], 'رمز عبور و تکرار آن مطابقت ندارند')
      .required('تکرار رمز عبور الزامی است')
});

export const validationAccountSchema = yup.object().shape({
    currentPassword: yup.string()
      .required('رمز عبور الزامی است')
      .min(5, 'رمز عبور باید حداقل 5 کاراکتر باشد'),
    password: yup.string()
      .required('رمز عبور الزامی است')
      .min(5, 'رمز عبور باید حداقل 5 کاراکتر باشد'),
    confirmPassword: yup.string()
      .oneOf([yup.ref('password'), null], 'رمز عبور و تکرار آن مطابقت ندارند')
      .required('تکرار رمز عبور الزامی است')
});

export const validationUserSchema = yup.object().shape({

});